// Templates and featured collections exist only in German or English: their
// `international` flag. Their language filter is the string the URL and the
// API carry: "false" (German), "true" (English) or "" (both).
// docs/exec-plans/content-locales-ai-content.md (D1).
export type InternationalFilter = "true" | "false" | "";

// German stays German; every other language counts as English, since that is
// what an international item is. German plus others, or nothing, is both.
export function internationalFilterForLocales(
  locales: readonly string[]
): InternationalFilter {
  const includesGerman = locales.includes("de");
  const includesOther = locales.some((locale) => locale !== "de");
  if (includesGerman === includesOther) return "";
  return includesGerman ? "false" : "true";
}

// The `international` API parameter; undefined (left out) means both.
export function internationalParam(filter?: string): boolean | undefined {
  if (filter === "true") return true;
  if (filter === "false") return false;
  return undefined;
}
